export const categories = [
  {
    id: 1,
    name: "All Posts",
    slug: "all",
    color: "#6B7280",
    icon: "📚",
    description: "All blog posts"
  },
  {
    id: 2,
    name: "Trade Finance",
    slug: "trade-finance",
    color: "#0066CC",
    icon: "🌍",
    description: "International trade financing insights"
  },
  {
    id: 3,
    name: "LPO Financing",
    slug: "lpo-financing",
    color: "#00AA55",
    icon: "📋",
    description: "Purchase order financing guides"
  },
  {
    id: 4,
    name: "Success Stories",
    slug: "success-stories",
    color: "#FF8800",
    icon: "⭐",
    description: "Client success case studies"
  },
  {
    id: 5,
    name: "How-To Guides",
    slug: "how-to-guides",
    color: "#8B5CF6",
    icon: "📖",
    description: "Step-by-step tutorials"
  },
  {
    id: 6,
    name: "Industry Trends",
    slug: "industry-trends",
    color: "#14B8A6",
    icon: "📈",
    description: "Market insights and analysis"
  }
];

export const getCategoryBySlug = (slug) => categories.find(cat => cat.slug === slug);